<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    >
      <template #start>
        <el-form-item v-if="user && [1, 6].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <template #end>
        <el-form-item
          class="endBtn"
          v-if="user && [1, 2, 3, 4, 6].includes(user.user_group_id)"
        >
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`维保列表`)"
            >导出</el-button
          >
        </el-form-item>
        <el-form-item
          class="endBtn"
          v-if="user && [1, 2, 3, 4].includes(user.user_group_id)"
        >
          <!-- 结算按钮 -->
          <el-button type="success" @click="settle">结算</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :pageSizes="pageSizes"
      :showIndex="true"
      :showTotal="true"
      :showSelect="user && [1, 2, 3, 4].includes(user.user_group_id)"
      :getTotal="getTotal"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template #open="params">
        <MySwitch
          :disabled="!user || ![1, 2, 3, 4].includes(user.user_group_id)"
          :data="params.params"
          :activeValue="'1'"
          :inactiveValue="'0'"
          @onToggle="toggleDisplay"
        ></MySwitch>
      </template>
      <template #btns="params">
        <!-- 查看按钮 -->
        <Btn :config="btns[0]" :data="params.params" />
        <!-- 编辑按钮，未结算才显示 -->
        <Btn
          v-show="params.params.settled != 1"
          :config="btns[1]"
          :data="params.params"
        />
        <!-- 删除按钮，未结算才显示 -->
        <Btn
          v-show="params.params.settled != 1"
          :config="btns[2]"
          :data="params.params"
        />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      pageSizes: [10, 50, 100, 200, 500, 2000],
      baseUrl: "repair",
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保列表", path: `/fix/list` },
      ],
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          ...this.ctrls.fleet,
          multiple: true,
          collapseTags: true,
          options: [],
        },
        {
          label: "维保类型",
          keyName: "article",
          placeholder: "请选择维保类型",
          type: "select",
          options: [],
        },
        {
          label: "维修商",
          keyName: "maunit",
          placeholder: "请填写维修商",
          type: "textSelect",
          // keyName: "reunitid",
          // placeholder: "请选择维修商",
          // type: "select",
          options: [],
        },
        {
          label: "维保时间",
          keyName: "month",
          placeholder: "请选择",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 90 },
        { keyName: "driver", label: "司机" },
        { keyName: "fleet_name", label: "车队长" },
        { keyName: "article_name", label: "维保类型" },
        { keyName: "maunit", label: "维修商", minwidth: 150 },
        { keyName: "rstarttime", label: "维保时间", minwidth: 100 },
        {
          keyName: "money",
          label: "花费金额",
          align: "right",
          className: "pr30",
          minwidth: 120,
        },
        {
          prop: "mileage",
          label: "行驶里程",
          align: "right",
          className: "pr30",
          minwidth: 120,
        },
        { keyName: "add_name", label: "填写人" },
        { keyName: "repair", label: "备注", minwidth: 150 },
        { keyName: "open", label: "结算", slot: "open" },
        { prop: "", label: "操作", slot: "btns", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(`/fix/detail?mode=view&id=${id}`);
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/fix/detail?mode=edit&id=${id}`);
          },
        },
        {
          ...this.delBtn,
          cb: this.delete,
        },
      ],
      getTotalProperty: ["money"],
      fleet: [],
      article: [],
    };
  },
  methods: {
    delete({ id }) {
      this.$prompt("删除原因", "确认删除吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.delReq(id, value);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    delReq(id, del_desc) {
      this.loading = true;
      let url = `repair/delre`;
      const params = {
        userid: this.user.id,
        id,
        del_desc,
      };
      params["headers"] = {
        "X-Method": "delete",
        "X-Module": "maintenance",
      };

      console.log(url, { ...params });

      this.post(
        url,
        params,
        ({ msg }) => {
          this.loading = false;
          if (msg == "success") {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "删除失败，请稍后重试！",
          });
        }
      );
    },
    onSearchItemChange({ key }) {
      if (
        [
          // 'fleet',
          "month",
          "article",
        ].includes(key)
      ) {
        this.getList();
      }
    },
    addItem() {
      this.$router.push(`/fix/detail`);
    },
    getOptions() {
      let url = `${this.baseUrl}/getsearch`;
      const params = {
        userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ fleet, article, reunit }) => {
          this.formCtrl.map((v) => {
            if (v.keyName === "fleet" && fleet && fleet.length) {
              this.fleet = fleet;
              // this.setCtrlOption(v, fleet, 'nickname')
              fleet.map((c) => {
                v.options.push({
                  label: c["nickname"],
                  value: c["id"],
                });
              });
            } else if (v.keyName === "article" && article && article.length) {
              this.article = article;
              this.setCtrlOption(v, article);
            } else if (v.keyName === "reunitid" && reunit && reunit.length) {
              this.setCtrlOption(v, reunit, "maunit");
            } else if (v.keyName === "maunit" && reunit && reunit.length) {
              this.setCtrlOption(v, reunit, "maunit", "maunit");
            }
          });
          this.$forceUpdate();
          this.setQueryParams();
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setQueryParams() {
      const { fleetname, name, months, monthe } = this.$route.query;
      if (fleetname) {
        this.fleet.map((v) => {
          // console.log({ ...v })
          if (v.nickname == fleetname) {
            this.formInline.fleet = v.id;
          }
        });
      }
      if (name) {
        this.article.map((v) => {
          // console.log({ ...v })
          if (v.name == name) {
            this.formInline.article = v.id;
          }
        });
      }
      if (months && monthe) {
        this.formInline.month = [months, monthe];
      }
      if (name || (months && monthe)) {
        this.$nextTick(this.getList);
      }
    },
    // 列表数据处理
    tableDataHandler({ count, data }) {
      this.total = count;
      if (data && data.length) {
        this.tableData = data.map((v) => {
          const obj = this.dataObjHandler(v);
          // 每条数据添加一条新的字段，对应switch控件开关值
          obj.open = v.settled + "";
          return obj;
        });
      }
      // console.log('list', this.tableData)
    },
    // 批量结算
    settle() {
      if (!this.selection.length) {
        this.$message({
          type: "warning",
          message: "请选择条目!",
        });
        return;
      }
      let count = 0;
      const arr = [];
      this.selection.map((v) => {
        count += Number(v.money);
        arr.push(v.id);
      });
      // console.log(this.selection)
      this.$confirm(`结算金额为${count}元？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.settleReq(arr);
        })
        .catch(() => {});
    },
    // 批量结算请求
    settleReq(delList) {
      let url = `${this.baseUrl}/settledrec`;
      const params = {
        // userid: this.user.id,
        delList,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
    // 单条结算
    toggleDisplay({ id }) {
      let url = `${this.baseUrl}/upsettled`;
      const params = {
        // userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.getList(true);
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
  },
  mounted() {
    this.getOptions();
    const { user_group_id, id } = this.user;
    // this.formInline.fleet = []
    if (![1, 6].includes(user_group_id)) {
      this.btns.length = 1;
      if (user_group_id == 5) {
        this.formInline.fleet = id;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .retrieval {
    .startBtn {
      margin-right: 20px;
    }

    // .reset {
    //   margin-right: 0;
    // }

    .el-input.el-input--suffix {
      width: 170px;
    }
  }
}
</style>
